
if($('.block--form').length > 0 || $('.flowchart-overview').length > 0){
    $('.gfield_radio input').on('change', function(){ 
        checkUnchecked(this);
    });

    // Rebind when new page is loaded
    $(document).bind('gform_page_loaded', function(event, form_id, current_page){
        $('.gfield_radio input').on('change', function(){ 
            checkUnchecked(this);
        });
    })
}

function checkUnchecked(input){
    var form = $(input).parents('.gform_wrapper'); 
    var currentPage = $(input).parents('.gform_page');

    if($(form).length > 0){
        if ($(currentPage).find($('.gform_page_fields:not(:has(:radio:checked))')).length) {
            // One field isn't checked
            return false;
        } else {
            // All radio buttons checked
            nextPage(currentPage);
        }
    }
}

function nextPage(currentPage){
    $(currentPage).find('.gform_next_button').click();
}
